export const SALES_CHANNELS = [
  { id: 'web', label: 'Web' },
  { id: 'mobile_app', label: 'App' },
  { id: 'ussd', label: 'USSD' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'box_office', label: 'Box office' },
  { id: 'agent', label: 'Agent' },
  { id: 'ai_mcp', label: 'AI MCP' },
  { id: 'complimentary', label: 'Comp' },
];

const CHANNEL_IDS = new Set(SALES_CHANNELS.map((channel) => channel.id));
const ALL_CHANNEL_IDS = SALES_CHANNELS.map((channel) => channel.id);

export function normalizeSalesChannelId(value) {
  const key = String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  return CHANNEL_IDS.has(key) ? key : null;
}

export function normalizeTicketSalesChannels(ticket = {}) {
  const access = ticket.channelAccess || ticket.salesChannelAccess || ticket.raw?.channelAccess || ticket.raw?.salesChannelAccess;
  if (Array.isArray(access)) {
    const blocked = new Set(access
      .filter((row) => row?.blocked === true)
      .map((row) => normalizeSalesChannelId(row?.channel || row?.id))
      .filter(Boolean));
    return ALL_CHANNEL_IDS.filter((id) => !blocked.has(id));
  }

  const explicit = ticket.salesChannels || ticket.raw?.salesChannels;
  if (Array.isArray(explicit)) {
    const ids = explicit.map(normalizeSalesChannelId).filter(Boolean);
    return ids.length ? [...new Set(ids)] : ALL_CHANNEL_IDS;
  }

  return ALL_CHANNEL_IDS;
}

export function normalizeTicketChannelAccess(ticket = {}) {
  const explicit = ticket.channelAccess || ticket.salesChannelAccess || ticket.raw?.channelAccess || ticket.raw?.salesChannelAccess;
  if (Array.isArray(explicit)) {
    return explicit
      .map((row) => ({
        channel: normalizeSalesChannelId(row?.channel || row?.id),
        blocked: row?.blocked === true,
        maxTickets: row?.maxTickets === null || row?.maxTickets === undefined || row?.maxTickets === ''
          ? null
          : Math.max(0, parseInt(row.maxTickets, 10) || 0),
      }))
      .filter((row) => row.channel && (row.blocked || row.maxTickets !== null));
  }
  return [];
}

export function salesChannelLabels(channelIds = []) {
  const labels = new Map(SALES_CHANNELS.map((channel) => [channel.id, channel.label]));
  return channelIds.map((id) => labels.get(id) || id);
}

export function hasCustomTicketChannelAccess(ticket = {}) {
  return normalizeTicketChannelAccess(ticket).length > 0;
}

export function ticketAllowsSalesChannel(ticket = {}, channelId) {
  const channel = normalizeSalesChannelId(channelId);
  if (!channel) return false;
  const access = normalizeTicketChannelAccess(ticket);
  const override = access.find((row) => row.channel === channel);
  return !override?.blocked;
}
